import {AppSettings} from "../../app-settings";
import {prop} from "../../decorators/property";
import {backboneModelProperties} from "../../decorators/backbone-properties";

export interface ITemplateAttributes {
    Compiled: () => string;
    Raw: string;
    Name: string;
}

@backboneModelProperties({
    defaults: {
        Name: null,
        Compiled: null,
        Raw: null
    }
})
export class TemplateModel extends Backbone.Model {

    @prop() public Loaded: boolean;
    @prop() public Raw: string;
    @prop() public Name: string;
    @prop() public Compiled: string;
    @prop() public Path: string;

    constructor(options?) {
        super(options);
        this.on("change", () => {
            this.compile();
        });
    }

    public load(): Promise<any> {
        return Promise.resolve($.get(this.Path)).then((data: any) => {
            this.Raw = data;
            this.Loaded = true;
        });
    }

    private compile(): void {
        this.Compiled = Mustache.parse(this.Raw);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/template-model.ts